<script setup>
import { ref, computed, useRouter } from '#imports';
import SearchAside from '~/components/news-page/search-aside/search-aside.vue';

defineProps({
  tags: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const emit = defineEmits(['fetchTag', 'search', 'resetTag']);
const activeTag = ref(router.currentRoute.value.query.tag);
const routeTag = computed(() => router.currentRoute.value.query.tag);

const toggleTagSelection = ({ name }) => {
  if (activeTag.value === name) {
    activeTag.value = '';
    emit('resetTag');
  } else {
    activeTag.value = name;
    emit('fetchTag', name);
  }
};

const handleSearch = (value) => {
  emit('search', value);
};
</script>

<template>
  <aside class="aside">
    <ul class="aside__list">
      <li>
        <SearchAside
          :tags="tags"
          @fetchTag="toggleTagSelection"
          @search="handleSearch"
        />
      </li>
      <li
        class="aside__item"
        :class="{ 'aside__item--active': routeTag === 'Эксклюзив DOXA' }"
        @click="
          toggleTagSelection({
            name: 'Эксклюзив DOXA',
          })
        "
      >
        <span>Эксклюзивы</span>
      </li>
      <li
        v-for="tag in tags"
        :key="tag.slug"
        class="aside__item"
        :class="{ 'aside__item--active': routeTag === tag.name }"
        :style="{ display: tag.name === 'Эксклюзив DOXA' ? 'none' : 'block' }"
        @click="toggleTagSelection(tag)"
      >
        <span>{{ tag.name }}</span>
      </li>
    </ul>
  </aside>
</template>

<style lang="postcss">
.aside {
  position: sticky;
  top: 0;
  height: 100vh;
  z-index: 1;

  &__list {
    list-style: none;
    gap: 6px;
    display: flex;
    flex-direction: column;
    padding: 20px 0;
  }

  &__item {
    border-radius: var(--border-radius);
    color: rgba(var(--text-dark-color--rgb), 0.9);
    padding: 6px 16px;
    box-shadow: 0 0 0 2px var(--accent-color) inset;
    font-family: var(--title-font-family);
    width: fit-content;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover {
      background-color: #682d72;
      color: #fff;
    }

    @media (max-width: 1024px) {
      font-size: 18px;
      line-height: 24px;
    }
  }

  &__item--active {
    background-color: #682d72;
    color: #fff;
  }
}
</style>
